<template>
  <!--
  <div
    style="
      z-index: 10000000000;
      background: #c00;
      color: #fff;
      position: fixed;
      width: auto;
      padding: 0 5px;
      left: 0;
    "
  >
    {{ deviceMode }}
  </div>
  -->
  <div class="wrapper">
    <slot name="header">
      <div class="header_wrapper">
        <div class="header">
          <div class="logo">
            <router-link to="/"
              ><img :src="require(`@/assets/egl_logo.svg`)"
            /></router-link>
          </div>
          <div class="main_menu">
            <nav class="navbar navbar-expand-lg navbar-light">
              <div class="collapse navbar-collapse">
                <ul class="navbar-nav">
                  <li
                    v-for="(item, idx) in mainMenu"
                    :key="idx"
                    class="nav-item"
                    :style="idx == mainMenu.length - 1 ? 'border: none' : ''"
                  >
                    <template v-if="item.isRouterLink">
                      <router-link :to="item.link">{{ item.name }}</router-link>
                    </template>
                    <template v-else>
                      <a :href="item.link" target="_blank">{{ item.name }}</a>
                    </template>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div class="top_menu">
            <span>
              <!-- <template v-if="member.memberId > 0">
                <span
                  class="unselect"
                  style="color: #19b0c1; font-weight: bold; padding-right: 8px"
                  >Hi, {{ member.firstnameEn }}&nbsp;{{
                    member.lastnameEn
                  }}</span
                ><a @click.stop="logout" style="cursor: pointer">登出</a>
              </template>
              <template v-else>
                <router-link to="/login">登入</router-link
                ><a class="unselect">|</a
                ><a
                  href="https://www.egltours.com/nmember-b2c-web/action/register/registerIndex.action"
                  target="_blank"
                  >註冊</a
                >
              </template> -->
              <a v-if="showSearchIcon" @click.stop="toggleSearchBar"
                ><i class="fas fa-search"></i
              ></a>
              <router-link to="/cart"
                ><i class="fas fa-shopping-cart"></i
                ><span
                  class="
                    position-absolute
                    top-0
                    start-100
                    translate-middle
                    badge
                    rounded-pill
                    bg-danger
                    my_pill
                  "
                  v-if="cartItem.counts > 0"
                >
                  {{ cartItem.counts }}
                  <span class="visually-hidden">unread messages</span>
                </span></router-link
              >
              <div class="cart_msg">
                <h6 style="line-height: 77px; color: #900">
                  已成功加入購物車！
                </h6>
              </div></span
            >
          </div>
          <div class="menu_wrapper">
            <nav class="navbar navbar-expand-lg navbar-light">
              <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <ul class="navbar-nav">
                  <li
                    class="nav-item"
                    v-for="(item, idx) in categories"
                    :key="idx"
                    :class="item.submenu.length > 0 ? 'dropdown' : ''"
                  >
                    <router-link
                      :to="'/product/' + item.link"
                      class="nav-link"
                      href="javascript:void(0);"
                      :id="'navbarDropdownMenuLink' + idx"
                      aria-expanded="false"
                      :class="item.submenu.length > 0 ? 'dropdown-toggle' : ''"
                    >
                      {{ item.title }}
                    </router-link>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="navbarDropdownMenuLink1"
                      v-if="item.submenu.length > 0"
                    >
                      <li v-for="i in item.submenu" :key="i.id">
                        <router-link
                          :to="'/product/' + i.link"
                          class="dropdown-item"
                          >{{ i.title }}</router-link
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div class="hamburger_box">
            <div class="hamburger hamburger--spin" id="hamburger">
              <div class="hamburger-box">
                <div class="hamburger-inner"></div>
              </div>
            </div>
          </div>
          <div
            class="browse_history"
            v-if="histories.length > 0"
            @click.stop="router.push('/history')"
          >
            已瀏覽產品
          </div>
        </div>
      </div>
      <div class="ham_overlay">
        <ul>
          <li v-for="item in mainMenu" :key="item.name">
            <template v-if="item.isRouterLink">
              <router-link :to="item.link" @click.stop="closeHamOverlay">{{
                item.name
              }}</router-link>
            </template>
            <template v-else>
              <a
                :href="item.link"
                target="_blank"
                @click.stop="closeHamOverlay"
                >{{ item.name }}</a
              >
            </template>
          </li>
          <li v-for="(item, idx) in categories" :key="idx">
            <router-link
              :to="'/product/' + item.link"
              @click.stop="closeHamOverlay"
              >{{ item.title }}</router-link
            >
            <ul v-if="item.submenu.length > 0">
              <li v-for="i in item.submenu" :key="i.id">
                <router-link
                  :to="'/product/' + i.link"
                  @click.stop="closeHamOverlay"
                  >{{ i.title }}</router-link
                >
              </li>
            </ul>
          </li>
          <li v-for="item in aboutUsMenu" :key="item.name">
            <template v-if="item.isRouterLink">
              <router-link :to="item.link" @click.stop="closeHamOverlay">{{
                item.name
              }}</router-link>
            </template>
            <template v-else>
              <a
                :href="item.link"
                target="_blank"
                @click.stop="closeHamOverlay"
                >{{ item.name }}</a
              >
            </template>
          </li>
          <li v-for="item in onlineServiceMenu" :key="item.name">
            <template v-if="item.isRouterLink">
              <router-link :to="item.link" @click.stop="closeHamOverlay">{{
                item.name
              }}</router-link>
            </template>
            <template v-else>
              <a
                :href="item.link"
                target="_blank"
                @click.stop="closeHamOverlay"
                >{{ item.name }}</a
              >
            </template>
          </li>
          <li v-for="item in termsAndPolicyMenu" :key="item.name">
            <template v-if="item.isRouterLink">
              <router-link :to="item.link" @click.stop="closeHamOverlay">{{
                item.name
              }}</router-link>
            </template>
            <template v-else>
              <a
                :href="item.link"
                target="_blank"
                @click.stop="closeHamOverlay"
                >{{ item.name }}</a
              >
            </template>
          </li>
        </ul>
      </div>
    </slot>
    <div class="wide_container">
      <SearchBar
        :isInline="false"
        :isShowLocation="true"
        v-if="showSearchBar"
      />
      <slot></slot>
    </div>
    <slot name="footer">
      <div class="footer_wrapper">
        <div class="narrow_container">
          <div class="footer">
            <table>
              <tr>
                <td>
                  <div class="unselect">關於我們</div>
                  <ul>
                    <li v-for="item in aboutUsMenu" :key="item.name">
                      <template v-if="item.isRouterLink">
                        <router-link :to="item.link">{{
                          item.name
                        }}</router-link>
                      </template>
                      <template v-else>
                        <a :href="item.link" target="_blank">{{ item.name }}</a>
                      </template>
                    </li>
                  </ul>
                </td>
                <td>
                  <div class="unselect">網上服務</div>
                  <ul>
                    <li v-for="item in onlineServiceMenu" :key="item.name">
                      <template v-if="item.isRouterLink">
                        <router-link :to="item.link">{{
                          item.name
                        }}</router-link>
                      </template>
                      <template v-else>
                        <a :href="item.link" target="_blank">{{ item.name }}</a>
                      </template>
                    </li>
                  </ul>
                </td>
                <td>
                  <div class="unselect">網站條款</div>
                  <ul>
                    <li v-for="item in termsAndPolicyMenu" :key="item.name">
                      <template v-if="item.isRouterLink">
                        <router-link :to="item.link">{{
                          item.name
                        }}</router-link>
                      </template>
                      <template v-else>
                        <a :href="item.link" target="_blank">{{ item.name }}</a>
                      </template>
                    </li>
                  </ul>
                </td>
                <td>
                  <div class="unselect">社交媒體</div>
                  <div style="padding: 0; margin: 0; padding-top: 12px">
                    <span
                      ><a
                        href="https://www.facebook.com/egltours"
                        target="_blank"
                        ><img
                          :src="require(`@/assets/facebook.png`)"
                          style="
                            width: 32px;
                            height: auto;
                            display: inline;
                            margin-right: 15px;
                            cursor: pointer;
                          " /></a
                    ></span>
                    <span
                      ><a
                        href="https://www.youtube.com/user/EGLChannel"
                        target="_blank"
                        ><img
                          :src="require(`@/assets/youtube.png`)"
                          style="
                            width: 36px;
                            height: auto;
                            display: inline;
                            cursor: pointer;
                          " /></a
                    ></span>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <div class="subscribe">
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control"
                placeholder="想接收最新優惠情報？"
                v-model="subscriber"
              />
              <button
                class="btn btn-primary"
                type="button"
                style="background-color: #19b0c1; border-color: #19b0c1"
                @click.stop="subscribe"
              >
                訂 閱
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="rights_container">
        <div class="copyright">
          <span
            >版權所有 © EGL Tours Company
            Limited&nbsp;&nbsp;&nbsp;旅行社牌照號碼：350805&nbsp;&nbsp;&nbsp;</span
          ><span>香港聯合交易所主板上市：股份代號6882</span>
        </div>
      </div>
    </slot>
    <div class="disable_click_layer"></div>
    <div class="back_to_top" @click="backToTop($event)">
      <img :src="require(`@/assets/back_to_top.svg`)" />
    </div>
    <div
      id="toast"
      class="toast align-items-center text-black bg-warning border-0"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div class="d-flex">
        <div class="toast-body">{{ toastMsg }}</div>
        <button
          type="button"
          class="btn-close btn-close-black me-2 m-auto"
          aria-label="Close"
          v-if="showCloseBtn"
          @click.stop="hideToast()"
        ></button>
      </div>
    </div>
    <div
      class="bottom_overlay"
      id="bottom_overlay"
      v-if="deviceMode != 'desktop'"
    >
      <div class="close_handler" @click.stop="closeBottomOverlay()">&nbsp;</div>
      <div class="bottom_overlay_content">
        <SearchBar :isInline="true" :isShowLocation="false" />
        <Location :categoryId="0" mode="search" componentKey="componentKey" />
      </div>
    </div>
    <div id="my_login_form" style="display: none; width: 0; height: 0"></div>
    <div style="display: none;">version: 1.29</div>
  </div>
</template>

<script>
import {
  ref,
  nextTick,
  onMounted,
  onBeforeUnmount,
  computed,
  inject,
} from "vue";
import SearchBar from "@/components/SearchBar.vue";
import Location from "@/components/Location.vue";
import { useStore } from "vuex";
import useEventBus from "@/config/eventBus";
import router from "@/router";
import axios from "axios";

export default {
  components: { SearchBar, Location },
  setup() {
    const showSearchBar = ref(false);
    const showSearchIcon = ref(true);
    const store = useStore();
    const eventBus = useEventBus();
    const subscriber = ref("");
    const emailRegex = inject("emailRegex");
    const mainMenu = inject("mainMenu");
    const aboutUsMenu = inject("aboutUsMenu");
    const onlineServiceMenu = inject("onlineServiceMenu");
    const termsAndPolicyMenu = inject("termsAndPolicyMenu");
    const toastMsg = ref("");
    const showCloseBtn = ref(true);
    const componentKey = ref(0);
    const categories = computed(() => store.getters["category/categories"]);
    const cartItem = computed(() => store.getters["cart/items"]);
    const histories = computed(() => store.getters["history/products"]);
    const member = computed(() => store.getters["member/info"]);
    const deviceMode = computed(() => store.getters["device/mode"]);

    const detectWindowWidth = () =>
      store.dispatch("device/setDeviceMode", window.innerWidth);

    const closeHamOverlay = () => {
      $(".hamburger").removeClass("is-active");
      $(".ham_overlay").stop().slideUp(300);
      $("html").css({
        overflowY: "auto",
      });
    };

    const openHamOverlay = () => {
      $(".hamburger").addClass("is-active");
      $(".ham_overlay").stop().slideDown(300);
      $("html").css({
        overflowY: "hidden",
      });
    };

    const closeBottomOverlay = () => {
      $("#bottom_overlay").stop().slideUp(300);
      $(".back_to_top").show();
      $("html").css({
        overflowY: "auto",
      });
    };

    const toggleSearchBar = () => {
      if (deviceMode.value == "desktop") {
        if (showSearchBar.value == true) showSearchBar.value = false;
        else showSearchBar.value = true;
      } else {
        $("#bottom_overlay").stop().slideDown(500);
        $(".back_to_top").hide();
        $("html").css({
          overflowY: "hidden",
        });
      }
    };

    const handleNextTick = async () => {
      await nextTick();
      componentKey.value += 1;
      $(document).on("click", ".hamburger", function () {
        if ($(".ham_overlay").is(":visible")) {
          closeHamOverlay();
        } else {
          openHamOverlay();
        }
      });
    };

    const backToTop = (e) => {
      e.preventDefault();
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        0
      );
      return false;
    };

    const subscribe = async () => {
      console.log(subscriber.value);
      if (subscriber.value.match(emailRegex)) {
        showCloseBtn.value = false;
        showToast("請稍候，系統處理中...！", false);
        const response = await axios.get(
          "https://www.egltours.com/guru-member-b2e/edmSubscription?email=" +
            subscriber.value
        );
        hideToast();
        if (response.data.success == 1) {
          setTimeout(() => {
            showToast("你已成功訂閱最新優惠情報！", true);
            subscriber.value = "";
          }, 200);
        } else {
          setTimeout(() => {
            showToast("Ops！訂閱失敗", true);
            subscriber.value = "";
          }, 200);
        }
      } else {
        showToast("請輸入有效電郵地址！", true);
      }
    };

    const logout = () => {
      showToast("請稍候，系統處理中...！", false);
      setTimeout(() => {
        store.dispatch("member/casLogout").then(() => {
          hideToast();
        });
      }, 1000);
    };

    const showToast = (_toastMsg, _warning) => {
      toastMsg.value = _toastMsg;
      if (_warning) {
        showCloseBtn.value = true;
        $(".d-flex").css({
          background: "#FFC107",
          color: "#000",
        });
        $("#toast").delay(4000).fadeOut();
      } else {
        $(".d-flex").css({
          background: "#FF8C00",
          color: "#FFF",
        });
        showCloseBtn.value = false;
      }
      $("#toast").show();
    };

    const hideToast = () => {
      $("#toast").hide();
      toastMsg.value = "";
    };

    detectWindowWidth();

    onMounted(() => {
      if (window.sessionStorage.getItem("vuex") != undefined) {
        const vuex = window.sessionStorage.getItem("vuex");
        console.log(JSON.parse(vuex).location.locations);
        if (
          JSON.parse(vuex).category != undefined &&
          JSON.parse(vuex).category.categories.length == 0
        ) {
          store.dispatch("category/setCategory");
        }
        if (
          JSON.parse(vuex).location != undefined &&
          JSON.parse(vuex).location.locations.length == 0
        ) {
          store.dispatch("location/setLocation").then(() => {
            componentKey.value += 1;
          });
        }
      }
      handleNextTick();

      window.addEventListener("resize", detectWindowWidth);

      eventBus.on("hideSearchBar", () => (showSearchBar.value = false));

      eventBus.on("hideBottomOverlay", () => closeBottomOverlay());

      eventBus.on("showSearchIcon", (bool) => {
        showSearchIcon.value = bool;
      });

      eventBus.on("showToast", (_toast) => {
        showToast(_toast.msg, _toast.warning);
      });

      eventBus.on("hasAddedToCart", () => {
        $("#toast").delay(100).fadeOut();
        $(".cart_msg").show();
        $(".cart_msg").delay(3000).fadeOut(300);
      });

      const offset = 480;
      const duration = 500;
      $(window).scroll(function () {
        if ($(this).scrollTop() > offset) {
          $(".back_to_top").fadeIn(duration);
        } else {
          $(".back_to_top").fadeOut(duration);
        }
      });
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", detectWindowWidth);
      eventBus.off("hideSearchBar");
      eventBus.off("hideBottomOverlay");
      eventBus.off("showSearchIcon");
      eventBus.off("hasAddedToCart");
      eventBus.off("showToast");
    });

    return {
      deviceMode,
      router,
      showSearchBar,
      closeHamOverlay,
      toggleSearchBar,
      categories,
      showSearchIcon,
      cartItem,
      histories,
      backToTop,
      subscribe,
      subscriber,
      toastMsg,
      hideToast,
      showCloseBtn,
      componentKey,
      member,
      logout,
      mainMenu,
      aboutUsMenu,
      onlineServiceMenu,
      termsAndPolicyMenu,
      closeBottomOverlay,
    };
  },
};
</script>

<style scoped>
.fas {
  cursor: pointer;
}
</style>